import type { Issue } from '@/types/issue';

const KEY = 'caprock:favorites';

export interface FavoriteRecord {
  id: string;
  kind: 'issue' | 'project';
  title: string;
  href: string;
  identifier?: string;
}

interface Store {
  items: FavoriteRecord[];
}

function read(): Store {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { items: [] };
    const parsed = JSON.parse(raw) as Store;
    if (!Array.isArray(parsed.items)) return { items: [] };
    return parsed;
  } catch {
    return { items: [] };
  }
}

function write(store: Store) {
  localStorage.setItem(KEY, JSON.stringify(store));
  window.dispatchEvent(new Event('caprock:favorites'));
}

export function listFavorites(): FavoriteRecord[] {
  return read().items;
}

export function isFavorite(id: string): boolean {
  return read().items.some((item) => item.id === id);
}

export function toggleIssueFavorite(issue: Issue): boolean {
  const store = read();
  const exists = store.items.some((item) => item.id === issue.id);
  if (exists) {
    write({ items: store.items.filter((item) => item.id !== issue.id) });
    return false;
  }

  const record: FavoriteRecord = {
    id: issue.id,
    kind: 'issue',
    title: issue.title,
    href: issue.identifier ? `/app/${issue.identifier}` : `/app/issues/${issue.id}`,
    identifier: issue.identifier,
  };
  write({ items: [record, ...store.items].slice(0, 30) });
  return true;
}

export function toggleProjectFavorite(project: { id: string; name: string }): boolean {
  const store = read();
  const exists = store.items.some((item) => item.id === project.id);
  if (exists) {
    write({ items: store.items.filter((item) => item.id !== project.id) });
    return false;
  }

  const record: FavoriteRecord = {
    id: project.id,
    kind: 'project',
    title: project.name,
    href: `/app/projects/${project.id}`,
  };
  write({ items: [record, ...store.items].slice(0, 30) });
  return true;
}
